// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1Hm7v","containerItemsCenter":"Skeleton_containerItemsCenter__3e3ye"};